import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";
import LoaderBox from "../HomePage/LoaderBox";

const AdminSettingsArhiva = ({ onBack }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [archiveList, setArchiveList] = useState([]);

  // State za formu
  const [showForm, setShowForm] = useState(false);
  const [editIndex, setEditIndex] = useState(null); // Ako je broj, uređujemo taj indeks
  const [winnerName, setWinnerName] = useState("");
  const [year, setYear] = useState("");

  // State za Delete Modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [indexToDelete, setIndexToDelete] = useState(null);

  useEffect(() => {
    fetchArchiveData();
  }, []);

  // 1. Dohvaćanje podataka iz site_settings (id = 1)
  const fetchArchiveData = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from("site_settings")
        .select("arhiva_pobjednika")
        .eq("id", 1)
        .single();

      if (error) throw error;

      if (data && data.arhiva_pobjednika) {
        // Sortiramo odmah pri učitavanju da admin vidi najnovije godine na vrhu
        const sorted = [...data.arhiva_pobjednika].sort(
          (a, b) => b.year - a.year,
        );
        setArchiveList(sorted);
      }
    } catch (err) {
      console.error("Greška pri dohvaćanju arhive:", err.message);
    } finally {
      setLoading(false);
    }
  };

  // 2. Spremanje cijelog niza natrag u Supabase
  const saveToSupabase = async (updatedList) => {
    try {
      setSaving(true);
      const { error } = await supabase
        .from("site_settings")
        .update({ arhiva_pobjednika: updatedList })
        .eq("id", 1);

      if (error) throw error;

      // Sortiramo i ažuriramo lokalni state
      const sorted = [...updatedList].sort((a, b) => b.year - a.year);
      setArchiveList(sorted);
      resetForm();
    } catch (err) {
      alert("Greška prilikom spremanja: " + err.message);
    } finally {
      setSaving(false);
    }
  };

  // 3. Pokretanje unosa / izmjene na gumb "Spremi"
  const handleSaveItem = (e) => {
    e.preventDefault();
    if (!winnerName.trim() || !year.trim()) {
      alert("Molimo ispunite oba polja!");
      return;
    }

    let updatedList = [...archiveList];

    if (editIndex !== null) {
      // Uređivanje postojećeg
      updatedList[editIndex] = { winner: winnerName.trim(), year: year.trim() };
    } else {
      // Dodavanje novog pobjednika
      updatedList.push({ winner: winnerName.trim(), year: year.trim() });
    }

    saveToSupabase(updatedList);
  };

  // 4. Pokretanje brisanja nakon potvrde u modalu
  const handleConfirmDelete = () => {
    if (indexToDelete === null) return;

    const updatedList = archiveList.filter((_, idx) => idx !== indexToDelete);
    saveToSupabase(updatedList);
    setShowDeleteModal(false);
    setIndexToDelete(null);
  };

  // Otvaranje forme za uređivanje
  const handleEditClick = (index, item) => {
    setEditIndex(index);
    setWinnerName(item.winner);
    setYear(item.year);
    setShowForm(true);
  };

  // Otvaranje modala za brisanje
  const handleDeleteClick = (index) => {
    setIndexToDelete(index);
    setShowDeleteModal(true);
  };

  const resetForm = () => {
    setShowForm(false);
    setEditIndex(null);
    setWinnerName("");
    setYear("");
  };

  if (loading) return <LoaderBox text="Učitavanje arhive..." />;

  return (
    <div className="admin-settings-container">
      <div className="back-btn-container" onClick={onBack}>
        <i className="fi fi-rs-angle-small-left"></i>
        <span>Natrag</span>
      </div>
      <div className="admin-header">
        <h3>Uredi "Arhivu Pobjednika"</h3>
      </div>

      <div className="admin-content-body">
        {/* Ako forma nije otvorena, prikaži gumb za dodavanje */}
        {!showForm && (
          <button
            className="admin-btn-primary"
            onClick={() => {
              resetForm();
              setShowForm(true);
            }}
            style={{ marginBottom: "20px" }}
          >
            <i className="fi fi-rs-plus" style={{ marginRight: "8px" }}></i>
            Dodaj pobjednika
          </button>
        )}

        {/* FORMA ZA UNOS / UREĐIVANJE */}
        {showForm && (
          <form
            className="admin-form-box"
            onSubmit={handleSaveItem}
            style={{ marginBottom: "30px" }}
          >
            <h4>
              {editIndex !== null ? "Uredi pobjednika" : "Novi pobjednik"}
            </h4>

            <div
              className="form-inputs-row"
              style={{ display: "flex", gap: "15px", marginBottom: "15px" }}
            >
              <div className="input-group" style={{ flex: 2 }}>
                <label>Ime ekipe</label>
                <input
                  type="text"
                  placeholder="Npr. Tomić AG"
                  value={winnerName}
                  onChange={(e) => setWinnerName(e.target.value)}
                />
              </div>

              <div className="input-group" style={{ flex: 1 }}>
                <label>Godina</label>
                <input
                  type="number"
                  placeholder="Npr. 2026"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                />
              </div>
            </div>

            <div
              className="form-actions"
              style={{ display: "flex", gap: "10px" }}
            >
              <button
                type="submit"
                className="admin-btn-save"
                disabled={saving}
              >
                {saving ? "Spremanje..." : "Spremi"}
              </button>
              <button
                type="button"
                className="admin-btn-cancel"
                onClick={resetForm}
                disabled={saving}
              >
                Odustani
              </button>
            </div>
          </form>
        )}

        {/* TABLICA / POPIS TRENUTNIH ZAPISA */}
        <div className="archive-list-wrapper">
          <h4>Trenutni pobjednici u bazi</h4>
          {archiveList.length === 0 ? (
            <p className="no-data-text">Nema upisanih pobjednika u arhivi.</p>
          ) : (
            <div className="admin-list-container">
              {archiveList.map((item, index) => (
                <div
                  key={index}
                  className="admin-list-item"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 15px",
                    background: "rgba(255,255,255,0.03)",
                    borderRadius: "8px",
                    marginBottom: "10px",
                  }}
                >
                  <div className="item-info">
                    <strong style={{ color: "#fff", fontSize: "1.1rem" }}>
                      {item.winner}
                    </strong>
                    <span
                      style={{
                        color: "#00f5d4",
                        marginLeft: "15px",
                        fontFamily: "Kanit",
                      }}
                    >
                      ({item.year}.)
                    </span>
                  </div>

                  <div
                    className="item-actions"
                    style={{ display: "flex", gap: "10px" }}
                  >
                    <button
                      className="btn-action-edit"
                      onClick={() => handleEditClick(index, item)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#00BFFF",
                        cursor: "pointer",
                      }}
                    >
                      <i className="fi fi-rs-edit"></i> Uredi
                    </button>
                    <button
                      className="btn-action-delete"
                      onClick={() => handleDeleteClick(index)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#FF4500",
                        cursor: "pointer",
                      }}
                    >
                      <i className="fi fi-rs-trash"></i> Obriši
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* CONFIRM DELETE MODAL */}
      {showDeleteModal && (
        <div
          className="admin-modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999,
          }}
        >
          <div
            className="admin-modal-box"
            style={{
              background: "#0f1922",
              padding: "25px",
              borderRadius: "12px",
              border: "1px solid rgba(0, 180, 255, 0.2)",
              textAlign: "center",
              maxWidth: "400px",
              width: "90%",
            }}
          >
            <h4 style={{ color: "#fff", marginBottom: "15px" }}>
              Jeste li sigurni?
            </h4>
            <p style={{ color: "#8fa0ba", marginBottom: "20px" }}>
              Želite li trajno obrisati ovog pobjednika iz arhive?
            </p>
            <div
              className="modal-actions"
              style={{ display: "flex", justifyContent: "center", gap: "15px" }}
            >
              <button
                className="admin-btn-del-confirm"
                onClick={handleConfirmDelete}
                style={{
                  background: "#FF4500",
                  color: "#fff",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                Da, obriši
              </button>
              <button
                className="admin-btn-del-cancel"
                onClick={() => setShowDeleteModal(false)}
                style={{
                  background: "rgba(255,255,255,0.1)",
                  color: "#fff",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Odustani
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSettingsArhiva;
